// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BXk2","head":"Table_head__UnAH4","col":"Table_col__KlyQe"};